const indexItems = [
  { label: '网红翻车合集', desc: '搞笑名场面', count: '326条' },
  { label: '直播爆料专区', desc: '实时吃瓜', count: '289条' },
  { label: '娱乐圈内幕', desc: '深度深扒', count: '254条' },
  { label: '综艺现场实录', desc: '突发状况', count: '198条' },
  { label: '素人投稿爆料', desc: '匿名分享', count: '176条' },
  { label: '主播黑料档案', desc: '行业乱象', count: '165条' },
  { label: 'CP塌房记录', desc: '甜蜜变翻车', count: '142条' },
  { label: '品牌翻车实录', desc: '消费警示', count: '128条' },
  { label: '音乐节事故', desc: '现场直击', count: '96条' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            内容导航
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            主题索引
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            按主题快速找到你感兴趣的吃瓜视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="bg-background-50 border border-background-200/60 hover:border-primary-200/50 rounded-xl p-5 flex items-center gap-4 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-primary-100 transition-colors">
                <span className="font-heading font-bold text-primary-600 text-sm md:text-base">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded-md shrink-0 whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}